import { type ComponentProps } from 'react';

interface LogoProps {
  icon?: string;
  title: string;
  size?: 'sm' | 'md' | 'lg';
  subtitle?: string;
  className?: string;
}

const sizeMap = {
  sm: { box: 'w-12 h-12', icon: 'text-2xl', title: 'text-xl' },
  md: { box: 'w-16 h-16', icon: 'text-3xl', title: 'text-2xl' },
  lg: { box: 'w-20 h-20', icon: 'text-4xl', title: 'text-3xl' },
};

export default function Logo({
  icon = 'ri-graduation-cap-line',
  title,
  size = 'md',
  subtitle,
  className = '',
}: LogoProps) {
  const s = sizeMap[size];

  return (
    <div className={`text-center ${className}`}>
      <div className={`${s.box} mx-auto mb-4 rounded-2xl bg-primary-500 flex items-center justify-center`}>
        <i className={`${icon} ${s.icon} text-background-50`}></i>
      </div>
      <h1 className={`${s.title} font-heading font-bold text-foreground-950 mb-1`}>
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm text-foreground-500">{subtitle}</p>
      )}
    </div>
  );
}